import { Button } from "@/components/ui";
import type { PickWhyView } from "@/lib/attributeReview/pickWhy";

import { StepNote } from "./StepNote";

type Props = {
  why: PickWhyView | null;
  readOnly: boolean;
  canIgnore: boolean;
  onIgnoreCopy: () => void;
};

export function PickWhy({ why, readOnly, canIgnore, onIgnoreCopy }: Props) {
  if (!why) return null;
  const { copy } = why;
  return (
    <StepNote
      tone="warn"
      title="The first pick was sent back."
      body={`${why.why}${why.alsoTried ? ` Also tried ${why.alsoTried}.` : ""}`}
    >
      {copy && !readOnly && !copy.ignore && <p>{copy.text}</p>}
      {copy && canIgnore && copy.ignore && (
        <Button size="sm" variant="outline" onClick={onIgnoreCopy}>
          {copy.text}
        </Button>
      )}
    </StepNote>
  );
}
